import { checkWithMediumJson } from './checkWithMediumJson';

/**
 * ตรวจสอบค่า MCHC โดยใช้ค่าปกติจาก medium.json
 * @param {string|number} value - ค่า MCHC
 * @param {number} age - อายุ (ปี)
 * @param {string|number} gender - เพศ (male/female หรือ 1/0)
 * @returns {Promise<object>} - {title, color, caption, suggest}
 */
export default async (value, age, gender) => {
  return await checkWithMediumJson(value, 'MCHC', gender, age, 'MCHC');
};
